import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

export default function HeroSection({ children }) {
  const { t } = useTranslation();

  return (
    <section className="py-4 shadow bg-connected-web">
      <Container fluid="lg">
        <Row className="align-items-center">
          <Col lg={6} sm={12} className="text-center">
            <h1 className="display-4 wrap-balance text-light text-shadow">
              <strong>{t("front_ai_title")}</strong>
            </h1>
            <p className="lead text-light text-shadow">
              {t("front_ai_subtitle")} <br />
              <span className="pilltext">{t("beta")}</span>
            </p>
          </Col>
          <Col lg={6} sm={12}>
            {children}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
